import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useUserContext } from '../../../../context/UserProvider'
import { fetchFleetReport, fetchFleetReportTerms } from '../../../../api/api'
import FleetReportTable from '../components/FleetReportTable'
import { ConsolidateInvoiceSelect } from '../../../cars/components/V3/_shared/ConsolidateInvoiceSelect'
import { useFilterOnConsolidateAgreement } from '../../hooks/useFilterOnConsolidateAgreement'
import { Select } from '../../../cars/components/V3/_shared/Select'
import type { Fleet } from '../../../../types'
import { ExcelExportButton } from '../components/ExcelExporter'
import { formatTerms } from '../../../../utils/helpers/helpers.reports'
import { fleetReportColumns } from '../components/FleetReportTable/excelUtils'

const FleetReport = () => {
  const { chosenCompany: company, fleetReportTerm } = useUserContext() as any
  const companyId = company?.id
  const [term, setTerm] = useState(fleetReportTerm || '')

  const { data: terms = [] } = useQuery(['fleetReportTerms', companyId], () => fetchFleetReportTerms(companyId), {
    enabled: !!companyId,
  }) as { data: string[] }

  const formattedTerms = formatTerms(terms)
  useEffect(() => {
    if (formattedTerms.length > 0 && term === '') {
      setTerm(formattedTerms[0].value)
    }
    localStorage.setItem('fleetReportTerm', term)
  }, [formattedTerms, term])

  const { data: response, status } = useQuery(
    ['fleetReport', companyId, term, 'fleet'],
    () => fetchFleetReport(companyId, term, 'fleet'),
    { enabled: !!companyId && !!term },
  )

  const data = (Array.isArray(response) ? response : response && 'data' in response ? response.data : []) as Fleet[]

  const agreementFilter = useFilterOnConsolidateAgreement()

  const filteredData = data
    .filter(agreementFilter('consolidatedAgreementID'))
    .filter((el) => el?.termDate?.startsWith(term))

  const excelData = filteredData.map((row) => ({
    ...row,
    HK: row.accountStatus === 'AVVIKLET' || row.accountStatus === 'ADM' ? 'ADM' : String(row.termsNow || ''),
  }))

  const config = {
    columns: fleetReportColumns(),
    filename: `Fleetrapport_${term}.xlsx`,
    sheetName: `Fleetrapport_${term}`,
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:justify-between">
        <div className="flex flex-row justify-between items-center">
          <span className="text-xl font-medium text-primaryText">Flåterapport</span>
          <div className="md:hidden">
            <ExcelExportButton data={excelData} config={config} />
          </div>
        </div>
        <div className="flex flex-row gap-2 w-full md:w-auto">
          <div className="flex-1 md:flex-none">
            <Select
              className="h-11 w-full"
              placeholder={'Termin'}
              options={formattedTerms}
              value={term}
              onChange={setTerm}
            />
          </div>
          <div className="flex-1 md:flex-none">
            <ConsolidateInvoiceSelect className="h-11 w-full" />
          </div>
          <div className="hidden md:block">
            <ExcelExportButton data={excelData} config={config} />
          </div>
        </div>
      </div>

      <FleetReportTable isLoading={status === 'loading'} data={filteredData} />
    </div>
  )
}

export default FleetReport
